import React from 'react';
import ReactDOM from 'react-dom';
import loadTranslations from 'js/localeSetup';

import HeroBanner from './heroBanner';
import './indexBanners.less';

(async () => {
  const rootElement = document.getElementById('indexBanners');
  await loadTranslations();

  if (rootElement) {
    ReactDOM.render(
      <div>
        <HeroBanner />
      </div>,
      rootElement
    );
  }
})();
